/* import __COLOCATED_TEMPLATE__ from './saml.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();